// Package Imports
import React, { FunctionComponent } from "react";

// Types
import { FilterData } from "@/lib/types/filters";

// Style Imports
import styles from "./pill.module.scss";

const Pill: FunctionComponent<FilterData> = ({ data, remove }) => {
  return (
    <div className={styles.wrapper}>
      <span className={styles.pill}>
        {data.name}
        <button
          type="button"
          className={styles.close}
          aria-label={`Remove ${data.name}`}
          onClick={() => remove(data)}
        >
          ×
        </button>
      </span>
    </div>
  );
};

export default Pill;
